module.exports = __webpack_public_path__ + "static/img/08_lea_cornelius_carstens.395d44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/lea/08_lea_cornelius_carstens.jpg
// module id = H5Te
// module chunks = 1